import { UserProfile, type UserSession } from "@/models/UserProfile";

type CognitoAttribute = {
  Name: string;
  Value: string | UserSession[];
};

export function mapCognitoAttributesToUserProfile(attributes: CognitoAttribute[]): UserProfile {
  const getValue = (name: string): string => {
    const attr = attributes.find(a => a.Name === name);
    return attr ? (attr.Value as string) : "";
  };

  const getSessions = (): UserSession[] => {
    const sessionsAttr = attributes.find(a => a.Name === "sessions");
    if (!sessionsAttr) return [];

    // Handle case where sessions might be a string (JSON)
    if (typeof sessionsAttr.Value === "string") {
      try {
        return JSON.parse(sessionsAttr.Value);
      } catch {
        return [];
      }
    }

    return sessionsAttr.Value as UserSession[];
  };

  return new UserProfile({
    email: getValue("email"),
    emailVerified: getValue("email_verified") === "true",
    twoFactorAuth: getValue("two_factor_auth") === "yes" ? "yes" : "no",
    country: getValue("custom:country"),
    salutation: getValue("custom:salutation"),
    lastName: getValue("custom:family_name"),
    companyName: getValue("custom:company_name"),
    firstName: getValue("custom:name"),
    locale: getValue("custom:locale"),
    jobTitle: getValue("custom:job_title"),
    industry: getValue("custom:industry"),
    interests: getValue("custom:interests").split(",").filter(Boolean),
    role: getValue("custom:role"),
    newsletter: getValue("custom:newsletter") === "yes" ? "yes" : "no",
    termsAccepted: getValue("custom:terms_accepted") === "yes" ? "yes" : "no",
    avatarUrl: getValue("custom:avatar"), // Changed from custom:avatar_url to custom:avatar
    sessions: getSessions(),
  });
}
